var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPauseCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.31748 9.43748V4.5625C5.31748 4.39212 5.4556 4.254 5.62598 4.254C5.79636 4.254 5.93448 4.39212 5.93448 4.5625V9.43748C5.93448 9.60786 5.79636 9.74598 5.62598 9.74598C5.4556 9.74598 5.31748 9.60786 5.31748 9.43748ZM8.06735 9.43748V4.5625C8.06735 4.39212 8.20547 4.254 8.37585 4.254C8.54623 4.254 8.68435 4.39212 8.68435 4.5625V9.43748C8.68435 9.60786 8.54623 9.74598 8.37585 9.74598C8.20547 9.74598 8.06735 9.60786 8.06735 9.43748ZM7 0.504C8.79346 0.504 10.4172 1.23101 11.5931 2.4069C12.769 3.58279 13.496 5.20654 13.496 7C13.496 8.79346 12.769 10.4172 11.5931 11.5931C10.4172 12.769 8.79346 13.496 7 13.496C5.20654 13.496 3.58279 12.769 2.4069 11.5931C1.23101 10.4172 0.504 8.79346 0.504 7C0.504 5.20654 1.23101 3.58279 2.4069 2.4069C3.58279 1.23101 5.20654 0.504 7 0.504ZM11.1569 2.84308C10.0933 1.77946 8.62312 1.121 7 1.121C5.37688 1.121 3.9067 1.77946 2.84308 2.84308C1.77946 3.9067 1.121 5.37688 1.121 7C1.121 8.62312 1.77946 10.0933 2.84308 11.1569C3.9067 12.2205 5.37688 12.879 7 12.879C8.62312 12.879 10.0933 12.2205 11.1569 11.1569C12.2205 10.0933 12.879 8.62312 12.879 7C12.879 5.37688 12.2205 3.9067 11.1569 2.84308Z",
    fill: "#7043FF",
    stroke: "#7043FF",
    strokeWidth: 0.507999
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseCircleIcon);
export default __webpack_public_path__ + "static/media/pause_circle_icon.ee8c4a022a98cdc87fd5c8b874927aa0.svg";
export { ForwardRef as ReactComponent };